module.exports = __webpack_public_path__ + "img/25.894dd3b6.png";